import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import Sidebar from '../components/layout/Sidebar';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

export default function MainLayout() {
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      <Sidebar />

      <Box sx={{ flexGrow: 1, minWidth: 0, minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: 'background.default' }}>
        <Header />

        <Box sx={{ flexGrow: 1, maxWidth: 1680, width: '100%', mx: 'auto', px: { xs: 2, md: 3 }, pt: 0.5, pb: { xs: 2, md: 3 } }}>
          <Outlet />
        </Box>

        <Footer />
      </Box>
    </Box>
  );
}
